import { composeIO } from 'react-compose-io'
import { tabelaArrastavelIO } from './TabelaArrastavel.IO'
import TabelaArrastavelView from './TabelaArrastavel.View'

export const TabelaArrastavel = composeIO(TabelaArrastavelView, tabelaArrastavelIO)
